<template>
  <div v-if="!getSubmitted" class="pre-register-wrapper">
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="visit-register">
    <div class="visit-register-header">
      <div class="logo-2">
        <img src="@/assets/images/logo-lg.svg" alt="-visipoint-logo" />
      </div>
      <p class="form-title">{{ $t('common.hello')}} {{ getFirstName }},</p>
      <p
        v-if="!$route.query.add_visitor"
        :class="qrInFlow ? 'sub-title' : 'noqr-sub-title'"
      >
        {{ $t('preRegisteration.visitRegistering') }} {{ getVisitDate ? $t('preRegisteration.forVisit') : "." }}
      </p>
      <p
        v-if="$route.query.add_visitor"
        :class="qrInFlow ? 'sub-title' : 'noqr-sub-title'"
      >
       {{ $t('preRegisteration.confirm_visit_invitation_msg')}}
      </p>
    </div>

    <div v-if="getRegisterPassportAcc" class="main-content">
      <div class="content-message">
        {{ mainMessage }}
      </div>
      <QRCode :url="getRegisteredUser.passport_qr" />
    </div>

    <div
      v-if="!getRegisterPassportAcc"
      class="main-content"
      :class="{ 'empty-cont': !getCompliance.is_qr_included }"
    >
      {{ mainMessage }}
      <QRCode
        v-if="getLocalQrCodeUrl && getCompliance.is_qr_included"
        :url="getLocalQrCodeUrl"
      />
      <QRCode
        v-if="
          getQrCodeUrl && getCompliance.is_qr_included && !getLocalQrCodeUrl
        "
        :url="getQrCodeUrl"
      />
    </div>

    <div
      v-if="getRegisterPassportAcc && getEmail"
      class="login-wrapper"
      :class="{ 'login-wrapper-noqr': !qrInFlow }"
    >
      <img
        class="check-email-icon"
        src="@/assets/images/check-email.svg"
        alt="check your email"
      />
      <p class="check-email-title">{{ $t('preRegisteration.checkEmail') }}</p>
      <p class="check-email-msg">
        {{ $t('preRegisteration.email_temporary_password') }}
      </p>
      <button
        @click="redirectTo()"
        :class="
          qrInFlow ? 'next-btn activ-btn mb-4' : 'noqr-next-btn activ-btn'
        "
        size="lg"
      >
      {{ $t('common.login').toUpperCase() }}
      </button>
    </div>

    <div
      v-if="getRegisterPassportAcc && getPhone && !getEmail"
      class="login-wrapper"
      :class="{ 'login-wrapper-noqr': !qrInFlow }"
    >
      <img
        class="check-email-icon"
        src="@/assets/images/check-phone-msg.svg"
        alt="check your email"
      />
      <p class="check-email-title">{{ $t('preRegisteration.checkMessage') }}</p>
      <p class="check-email-msg">
        {{ $t('preRegisteration.sms_temporary_password') }}
      </p>
      <button
        @click="redirectTo()"
        :class="
          qrInFlow ? 'next-btn activ-btn mb-4' : 'noqr-next-btn activ-btn'
        "
        size="lg"
      >
        {{ $t('common.login').toUpperCase() }}
      </button>
    </div>

    <button
      v-if="getFromLogin"
      @click="redirectTo()"
      :class="qrInFlow ? 'next-btn activ-btn ' : 'noqr-next-btn activ-btn'"
      size="lg"
    >
    {{ $t('preRegisteration.go_to_passport') }}
    </button>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import QRCode from "@/components/QRCode.vue";
export default {
  beforeMount() {
    const currentId = this.$route.params.id;
    if (!this.getSubmitted) {
      const newPath = `/${process.env.VUE_APP_PRE_REGISTRATION_URL}/${currentId}`;
      this.$router.push(newPath);
    }
  },
  mounted() {
    this.qrInFlow = this.getCompliance.is_qr_included;
    this.compliance = this.getCompliance.is_compliance_required;
    console.log(this.getCompliance);
    console.log(this.getFirstName);
    console.log(this.getRegisterPassportAcc);
    console.log(
      "getExpectedDateTime",
      this.getExpectedDateTime,
      this.getPreRegistrationData
    );
    // setTimeout(() => {
    //   console.log("usertype", this.getSelectedUserType);
    // }, 5000);
  },
  components: {
    QRCode,
  },
  data() {
    return {
      qrInFlow: null,
      compliance: null,
      showQr: null,
      commingFromLogin: false,
      // commingFromRegister: true,
    };
  },

  watch: {},
  computed: {
    ...mapGetters("preRegistration", [
      "getExpectedDateTime",
      "getRegisteredUser",
      "getSelectedUserType",
      "getSelectedEntity",
      "getSelectedArea",
      "getFirstName",
      "getCompliance",
      "getEmail",
      "getVisitDate",
      "getVisitTime",
      "getPhone",
      "getRegisterPassportAcc",
      "getLocalQrCodeUrl",
      "getDifferentUserType",
      "getQrCodeUrl",
      "getFromLogin",
      "getDaysDiff",
      "getOffset",
      "getSubmitted",
    ]),
    ...mapGetters("userType", [
      "getPreRegAreaDetails",
      "getPreRegistrationData",
    ]),
    formattedDate() {
      const visit_date =
        this.getDaysDiff != 0
          ? new Date(
              Date.parse(new Date(this.getVisitDate)) +
                this.getDaysDiff * 24 * 60 * 60 * 1000
            )
          : new Date(this.getVisitDate);
      return `${visit_date.getUTCDate()} ${visit_date.toLocaleString(
        "default",
        {
          month: "long",
        }
      )} ${visit_date.getFullYear()}`;
    },
    formattedTime() {
      const visit_time = new Date(this.getVisitTime);
      if (this.getOffset != 0)
        visit_time.setTime(visit_time.getTime() - this.getOffset);
      return visit_time.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
      // const visit_time = this.getVisitTime;
      // return visit_time;
    },
    mainMessage() {
      let msg = "";
      const approvalRequiredMethods = [
        "PRE_REGISTERED_WITH_APPROVAL_REQUIRED",
        "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED"
      ];

      if (approvalRequiredMethods.includes(this.getSelectedUserType[0].pre_registration_method)) {
        msg += this.compliance ? this.$t('preRegisteration.youRe') : this.$t('preRegisteration.willBe');
      } else {
        msg += this.$t('preRegisteration.youRe');
      }
      msg+= " "

      if (this.compliance && this.getVisitDate) {
        msg += this.$t('preRegisteration.expected')+" ";
      } else {
        msg += this.$t('preRegisteration.ready')+" ";
      }
      msg += `${this.$t('preRegisteration.toVisit')} “${this.getPreRegAreaDetails.site.name
        .toLowerCase()
        .replace(
          /^./,
          this.getPreRegAreaDetails.site.name[0].toUpperCase()
        )} - ${this.getPreRegAreaDetails.name
        .toLowerCase()
        .replace(
          /^./,
          this.getPreRegAreaDetails.name[0].toUpperCase()
        )}” ${this.$t('addExpectedVisitor.asA')} “${this.getSelectedUserType[0].name
        .toLowerCase()
        .replace(/^./, this.getSelectedUserType[0].name[0].toUpperCase())}” `;
      if (this.getVisitDate && !this.$route.query.add_visitor) {
        msg += `${this.$t('common.on')} ${this.formattedDate} ${this.$t('common.at')} ${this.formattedTime} `;
      } else if (this.$route.query.add_visitor) {
        const date = moment
          .utc(this.getExpectedDateTime)
          .tz(this.getPreRegistrationData.timeZone)
          .format("DD MMMM YYYY", "en");
        const time = moment
          .utc(this.getExpectedDateTime)
          .tz(this.getPreRegistrationData.timeZone)
          .format("hh:mm A");
        msg += `${this.$t('common.on')} ${date} ${this.$t('common.at')} ${time} `;
      } else {
        msg += this.$t('preRegisteration.atAnyTime') + " ";
      }
      if (this.qrInFlow) {
        msg += !this.getRegisterPassportAcc && this.getLocalQrCodeUrl ? this.$t('preRegisteration.usingLocal'): this.$t('preRegisteration.usingPassport')
      } else if (
        this.getCompliance.is_rfid_included ||
        this.getCompliance.is_face_id_included
      ) {
        msg += this.$t('preRegisteration.usingUr')+" ";
        if (
          this.getCompliance.is_face_id_included &&
          this.getCompliance.is_rfid_included
        )
          msg += this.$t('preRegisteration.faceIdOrAccessCard');
        else if (this.getCompliance.is_rfid_included) msg += `“${this.$t('preRegisteration.accessCard')}”`;
        else if (this.getCompliance.is_face_id_included) msg +=`“${this.$t('preRegisteration.faceId')}”`;
        if (this.getCompliance.is_using_kiosk_screen)
          msg +=`${this.$t('common.or')} ${this.$t('preRegisteration.usingKiosk')}`;
      } else if (this.getCompliance.is_using_kiosk_screen)
        msg += this.$t('preRegisteration.usingKiosk');
      if (this.compliance) {
        msg += ".";
        if (this.getEmail || this.getPhone) {
          msg += ` ${this.getEmail ? this.$t('preRegisteration.checkEmailForFillCompliance') : this.$t('preRegisteration.checkPhoneForFillCompliance')}` 
        }
      } else {
        if (
          this.getSelectedUserType[0].pre_registration_method ==
            "PRE_REGISTERED_WITH_APPROVAL_REQUIRED" ||
          this.getSelectedUserType[0].pre_registration_method ==
            "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED"
        ) {
          msg += ` ${this.$t('preRegisteration.adminApproval') }`;
          if (this.getEmail || this.getPhone) {
            msg += this.getEmail ? this.$t('preRegisteration.checkEmailForUpdate') : this.$t('preRegisteration.checkPhoneForUpdate'); 
          }
        } else {
          msg += `${this.qrInFlow ? ":" : "."}`;
        }
      }
      return msg;
    },
  },

  methods: {
    ...mapActions("preRegistration", ["createExpectedVisit"]),
    redirectTo() {
      window.location.href = `${
        process.env.VUE_APP_BASE_URL_PASSPORT_REDIRECT
      }/login?${
        this.getEmail ? "&email=" + encodeURIComponent(this.getEmail) : ""
      }
          ${
            this.getPhone ? "&phone=" + encodeURIComponent(this.getPhone) : ""
          }`;
    },
  },
};
</script>

<style lang="scss" scoped>
.visit-register {
  margin: auto;
  margin-top: 86px;
  margin-bottom: 86px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 710px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
  border-radius: 26px;
  .main-content-msg {
    margin-bottom: 0px;
  }
  //   header
  .visit-register-header {
    .logo-2 {
      display: block;
      width: 116px;
      height: 22px;
      margin: 59px auto 66px auto;
      img {
        width: 126px;
        height: 24px;
      }
    }
    .form-title {
      font-family: "Roboto";

      font-weight: 900;
      font-size: 30px;
      line-height: 35px;
      text-align: center;

      color: #000000;
    }
    .sub-title {
      font-family: "Roboto";

      font-weight: 700;
      font-size: 16px;
      line-height: 30px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #000000;
      margin-top: 15px;
      margin-bottom: 30px;
    }
    .noqr-sub-title {
      font-weight: 700;
      font-size: 16px;
      line-height: 30px;

      text-align: center;
      letter-spacing: 0.25px;

      color: #000000;
      margin-bottom: 30px;
    }
    .not-allow-reg-sub-title {
      @extend .noqr-sub-title;
      margin-top: 164px;
      margin-bottom: 14px;
    }
    .diff-usr-type-sub-title {
      @extend .not-allow-reg-sub-title;
    }
  }
  .main-content {
    text-align: center;
    margin: 0 110px 53px 110px;

    font-weight: 400;
    font-size: 14px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #666666;

    .content-message {
      font-family: "Roboto";

      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #787878;

      text-align: center;
      margin: 0 0px;
    }
    .qr-wrapper {
      width: 208px;
      height: 231px;
      background-color: #f3f3f3;
      border-radius: 8px;
      border: 2.5px solid #f3f3f3;
      margin: 49px auto 59px Auto;
      padding: 37px 33px 0px 33px;

      img {
        border-radius: 11px;
        border: 6.5px solid #000000;
        margin-bottom: 8px;
        width: 143px;
        height: 143px;
      }
      a {
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        margin-bottom: 26px;
        color: #000000;

        white-space: nowrap;
      }
    }
    .apple-wallet-btn {
      border-radius: 0px;
      margin-bottom: 20px;
    }
    .googlepay-wallet-btn {
      margin-bottom: 68px;
    }
  }
  .no-qr-main-content {
    width: 390px;
    margin: 0 auto 47px;
  }
  .not-allow-reg-main-content {
    margin-bottom: 45px;
  }
  .diff-user-type-main-content {
    margin-bottom: 68px;
  }
  .next-btn {
    height: 33px;
    width: 283px;
    border-radius: 18.5px;
    text-align: center;
    margin: 0 auto 44.5px;

    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
  }
  .noqr-next-btn {
    height: 37px;
    width: 197px;
    border-radius: 18.5px;
    text-align: center;
    margin: 0 auto 33px;
    line-height: 37px !important;
    letter-spacing: 0.25px;
    font-size: 14px;
  }
  .yes-no-wrapper {
    display: flex;
    justify-content: center;
  }
  .yes-btn {
    height: 37px;
    width: 147px;
    border-radius: 18.5px;
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: center;
    margin-inline-end: 18px;
  }
  .change-user-typebtn {
    height: 37px;
    width: 147px;
    border-radius: 18.5px;
    border: 2.5px solid #103f5e;
    background-color: #fff;
    color: #103f5e !important;
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: center;
  }
  .login-wrapper {
    width: 386px;
    // height: 299px;
    border-radius: 17px;
    background-color: #f2f2f2;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: space-around;
    margin: 0px auto 95px auto;
    .check-email-icon {
      margin-top: 53px;
      margin-bottom: 24px;
    }
    .check-email-title {
      font-family: "Roboto";

      font-weight: 900;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      color: #103f5e;
    }
    .check-email-msg {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #666666;
      margin: 0px 33px 35px 32px;
    }
  }
}
@media (max-width: 992px) {
  .visit-register {
    margin: auto;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 390px;
    text-align: center;
    background: #ffffff;
    box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
    border-radius: 0px;
    .main-content-msg {
      margin-bottom: 0px;
    }
    //   header
    .visit-register-header {
      .logo-2 {
        display: block;
        width: 116px;
        height: 22px;
        margin: 75px auto 49px auto;
        img {
          width: 116px;
          height: 22px;
        }
      }
      .form-title {
        font-family: "Manrope";

        font-weight: 800;
        font-size: 17px;
        line-height: 23px;
        text-align: center;

        color: #000000;
      }
      .sub-title {
        font-weight: 500;
        font-size: 14px;
        line-height: 30px;
        text-align: center;
        letter-spacing: 0.25px;

        color: #000000;
        margin-top: 24px;
        margin-bottom: 8px;
      }
      .noqr-sub-title {
        font-weight: 400;
        font-size: 16px;
        line-height: 30px;
        text-align: center;
        letter-spacing: 0.25px;

        color: #000000;
        margin-top: 143px;
        margin-bottom: 8px;
      }
      .not-allow-reg-sub-title {
        @extend .noqr-sub-title;
        margin-top: 164px;
        margin-bottom: 14px;
      }
      .diff-usr-type-sub-title {
        @extend .not-allow-reg-sub-title;
      }
    }
    .main-content.empty-cont {
      margin-bottom: 47px;
    }
    a.noqr-next-btn.activ-btn {
      margin-bottom: 316px !important;
    }
    .main-content {
      text-align: center;
      margin-inline-start: 37px !important;
      margin: 0 37px 59px 37px;

      font-weight: 400;
      font-size: 14px;
      line-height: 27px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #666666;

      .content-message {
        font-family: "Roboto";

        font-weight: 400;
        font-size: 14px;
        line-height: 27px;
        text-align: center;
        letter-spacing: 0.25px;
        color: #787878;

        text-align: center;
        margin: 0 0px;
      }
      .qr-wrapper {
        width: 162px;
        height: 162px;
        background-color: #f3f3f3;
        border-radius: 8px;
        border: 2.5px solid #f3f3f3;
        margin: 49px auto 59px Auto;
        padding-top: 19px;
        padding-inline-end: 25px;
        padding-bottom: 0px;
        padding-inline-start: 26px;

        img {
          border-radius: 11px;
          border: 6.5px solid #000000;
          margin-bottom: 6.5px;
          width: 111px;
          height: 111px;
        }
        a {
          font-weight: 700;
          font-size: 14px;
          line-height: 17px;
          text-align: center;
          margin-bottom: 8px;
          color: #000000;
          white-space: nowrap;
        }
      }
      .apple-wallet-btn {
        border-radius: 0px;
        margin-bottom: 20px;
      }
      .googlepay-wallet-btn {
        margin-bottom: 68px;
      }
    }
    .no-qr-main-content {
      width: 390px;
      margin: 0 auto 47px;
    }
    .not-allow-reg-main-content {
      margin-bottom: 45px;
    }
    .diff-user-type-main-content {
      margin-bottom: 68px;
    }
    .next-btn {
      height: 37px;
      width: 265px;
      border-radius: 18.5px;
      text-align: center;
      margin: 0 auto 73px;

      font-weight: 500;
      font-size: 16px;
      line-height: 17px;
      text-align: center;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
    }
    .noqr-next-btn {
      height: 37px;
      width: 197px;
      border-radius: 18.5px;
      text-align: center;
      margin: 0 auto 33px;
      line-height: 37px !important;
      letter-spacing: 0.25px;
      font-size: 14px;
    }
    .yes-no-wrapper {
      display: flex;
      justify-content: center;
    }
    .yes-btn {
      height: 37px;
      width: 147px;
      border-radius: 18.5px;
      font-size: 14px;
      font-weight: 700;
      line-height: 17px;
      letter-spacing: 0.25px;
      text-align: center;
      margin-inline-end: 18px;
    }
    .change-user-typebtn {
      height: 37px;
      width: 147px;
      border-radius: 18.5px;
      border: 2.5px solid #103f5e;
      background-color: #fff;
      color: #103f5e !important;
      font-size: 14px;
      font-weight: 700;
      line-height: 17px;
      letter-spacing: 0.25px;
      text-align: center;
    }
    .login-wrapper {
      width: 316px;
      // height: 299px;
      border-radius: 17px;
      background-color: #f2f2f2;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-content: space-around;
      margin: 0px auto 72px auto;
      .check-email-icon {
        margin-top: 39px;
        margin-bottom: 24px;
      }
      .check-email-title {
        font-family: "Roboto";

        font-weight: 900;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        color: #103f5e;
        margin-bottom: 20px !important;
      }
      .check-email-msg {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        letter-spacing: 0.25px;
        color: #666666;
        margin: 0px 25px 21px 24px;
      }
    }
    .login-wrapper.login-wrapper-noqr {
      margin: 0px auto 162px auto;
    }
  }
}
</style>
